(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/utils/campaigns.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/utils/campaigns.js');
"use strict";

const ids = {
  LYCKOPLATSEN: 'lpn_nkdvhr_23-25_26'
};
const names = {
  [ids.LYCKOPLATSEN]: 'lyckoplatsen'
};
const campaignMappings = {
  [ids.LYCKOPLATSEN]: ids.LYCKOPLATSEN,
  f9RkJ0aMU5K5NywjPJHUx: ids.LYCKOPLATSEN,
  [names[ids.LYCKOPLATSEN]]: ids.LYCKOPLATSEN
};
const images = {
  [ids.LYCKOPLATSEN]: {
    1: "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presenttriss-lyckoplatsen-1.png"),
    3: "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presenttriss-lyckoplatsen-3.png")
  }
};
const getCampaignImage = function (campaign) {
  let amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const campaignId = campaignMappings[campaign];
  if (campaignId && images[campaignId]) {
    if (images[campaignId][amount]) {
      return images[campaignId][amount];
    }
    const availableAmounts = Object.keys(images[campaignId]).map(Number).sort((a, b) => a - b);
    const closestAmount = availableAmounts.reduce((prev, curr) => curr <= amount ? curr : prev, 0);
    if (closestAmount > 0) {
      return images[campaignId][closestAmount];
    }
  }
  return undefined;
};
setGlobal('svs.ticket_gifts.utils.campaign', {
  ids,
  campaignMappings,
  names,
  images,
  getCampaignImage
});

 })(window);